import { gql } from '@apollo/client';
const queryOrganization = (organizationUri: string) => {
    return {
        variables: { organizationUri },
        query: gql`
            query GetOrganization($organizationUri: String!) {
                getOrganization(organizationUri: $organizationUri) {
                    label
                    organizationUri
                    created
                    owner
                    SamlGroupName
                    description
                    userRoleInOrganization
                    environments {
                        count
                    }
                }
            }
        `,
    };
};
export default queryOrganization;
